module.exports = __webpack_public_path__ + "img/75572.cdcfaf14.svg";